import { render } from "./CharlaTermsPopup.vue?vue&type=template&id=fb38d608&scoped=true"
import script from "./CharlaTermsPopup.vue?vue&type=script&lang=js"
export * from "./CharlaTermsPopup.vue?vue&type=script&lang=js"

import "./CharlaTermsPopup.vue?vue&type=style&index=0&id=fb38d608&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb38d608"]])

export default __exports__